export default "__VITE_ASSET__fecde303__"